import React from 'react'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import {
    CLASSNAME
} from '../../../business-const/Style/Style'

import {
    anonimizarNome,
} from '../../../business-components/String/String'

import {
    GridContainerReport,
    GridItem4,
    GridItem5,
    GridItem6,
    GridItem7,
    GridItem8,
    GridItem11,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    formataReportConferenciaDados,
} from '../../../business-components/Formata/Formata'

import {
    pesquisaList,
} from '../../../business-rules/List/ListService'

import {
    informouObjetivos,
} from '../cadastro-form/CadastroServiceObjetivos'

//import {
//    relatorioModoApresentacao,
//} from '../estudo-form/EstudoService'

import familiaresList from '../../../business-rules/List/familiaresList'

import {
    AvatarClienteConjugeFamiliarView
} from '../cadastro-form/CadastroCompClienteConjugeFamiliares'

import EstudoReportConferenciaDadosFamiliares from './EstudoReportConferenciaDadosFamiliares'

import EstudoReportConferenciaDadosParametros from './EstudoReportConferenciaDadosParametros'

import EstudoReportConferenciaDadosClienteConjuge from './EstudoReportConferenciaDadosClienteConjuge'

import EstudoFormObjetivos from '../estudo-form/EstudoFormObjetivos'



const EstudoReportConferenciaDados = ({ values, report, vars, somenteClienteConjugeFamiliares,
    somenteClienteConjugeFamiliaresTaxas, incluirObjetivos }) => {
 
    const DadosClienteConjuge = ({ item }) => {

        return (
            <>
                <span
                    className={!item.avatar && vars.jsonConfiguracao.whiteLabel[vars.indexIdWhiteLabel].naoExibirAvatarClienteConjuge ? 'font-bold' : 'text-15'}
                >
                    {!vars.jsonConfiguracao.anonimizarRelatorio || !report || values.modoApresentacao
                        ?
                            item.nome
                        :
                            anonimizarNome(item.nome)
                    }
                </span>
                <br/>

                {(item.avatar || !vars.jsonConfiguracao.whiteLabel[vars.indexIdWhiteLabel].naoExibirAvatarClienteConjuge) && (
                    <GridItem12
                        className='bg-default'>
                        <br/>
                    </GridItem12>
                )}

                {item.descricao
                    ?
                        <>
                            <br/>
                            {formataReportConferenciaDados(LABEL.nomeCurto,item.descricao)}
                        </>
                    :
                        ''
                }

                {item.cpfFormatado
                    ?
                        <>
                            <br/>
                            {formataReportConferenciaDados(LABEL.cpf, item.cpfFormatado)}
                        </>
                    :
                        ''
                }

                {item.nascimentoFormatado
                    ?
                        <>
                            <br/>
                            {formataReportConferenciaDados(LABEL.nascimento,
                                item.nascimentoFormatado)}
                        </>
                    :
                        ''
                }

                {item.idade
                    ?
                        <>
                            <br/>
                            {formataReportConferenciaDados(LABEL.idade, item.idade)}
                        </>
                    :
                        ''
                }

                {item.sexoDescricao
                    ?
                        <>
                            <br/>
                            {formataReportConferenciaDados(LABEL.sexo, item.sexoDescricao)}
                        </>
                    :
                        ''
                }

                {item.grauInstrucaoDescricao
                    ?
                        <>
                            <br/>
                            {formataReportConferenciaDados(LABEL.grauInstrucao,
                                item.grauInstrucaoDescricao)}
                        </>
                    :
                        ''
                }

                {item.formacao
                    ?
                        <>
                            <br/>
                            {formataReportConferenciaDados(LABEL.formacao,
                                item.formacao)}
                        </>
                    :
                        ''
                }

                {item.profissao
                    ?
                        <>
                            <br/>
                            {formataReportConferenciaDados(LABEL.profissao,
                                item.profissao)}
                        </>
                    :
                        ''
                }

                {item.empresa
                    ?
                        <>
                            <br/>
                            {formataReportConferenciaDados(LABEL.empresa,
                                item.empresa)}
                        </>
                    :
                        ''
                }

                {item.tipoRegimeBensDescricao
                    ?
                        <>
                            <br/>
                            {formataReportConferenciaDados(LABEL.tipoRegimeBens,
                                item.tipoRegimeBensDescricao)}
                        </>
                    :
                        ''
                }

                {item.contatosDescricao
                    ?
                        <>
                            <br/>
                            {formataReportConferenciaDados(LABEL.contatos, '')}
                            <div
                                className={CLASSNAME().formataReportConferenciaDadosConteudo}
                                dangerouslySetInnerHTML={{ __html: 
                                    item.contatosDescricao
                                }}
                            />
                        </>
                    :
                        ''
                }
            </>
        )
    }


    const ClienteConjuge = ({ item }) => {

        return (
            (item.avatar || !vars.jsonConfiguracao.whiteLabel[vars.indexIdWhiteLabel].naoExibirAvatarClienteConjuge) &&
            (!vars.jsonConfiguracao.anonimizarRelatorio || !report || values.modoApresentacao)
                ?
                    <>
                        <GridItem4
                            align="center"
                        >
                            <AvatarClienteConjugeFamiliarView
                                value={item.avatar}
                                sexo={item.sexo}
                            />
                        </GridItem4>

                        <GridItem8>
                            <DadosClienteConjuge
                                item={item}
                            />
                        </GridItem8>
                    </>
                :
                    <GridItem11
                        className='ml-3 mt-2 mb-3'
                    >
                        <DadosClienteConjuge
                            item={item}
                        />
                    </GridItem11>
        )
    }



    return (
        <div
            //className={(!report && relatorioModoApresentacao(values) ? 'mt-10 ml-5 mr-5' : '')} // mudança da fonte: acrescentou mt-10
        >
            {values.disposicaoRelatorio === HARDCODE.disposicaoRelatorioPaisagem &&
            !somenteClienteConjugeFamiliares & !somenteClienteConjugeFamiliaresTaxas && !incluirObjetivos
                ?
                    <>
                        <GridContainerReport
                            align='left'
                        >
                            <GridItem5>
                                {familiaresList(values)?.map((item, ind) => {
                                    return item.id <=
                                    (pesquisaList(values.exclusaoFamiliares, HARDCODE.idFamiliarConjuge).id ? HARDCODE.idFamiliarCliente : HARDCODE.idFamiliarConjuge) ? (
                                        <GridContainerReport
                                            key={ind}
                                            className='mt-3 mb-10'
                                        >
                                            <ClienteConjuge
                                                item={item}
                                            />
                                        </GridContainerReport>
                                    )
                                    :
                                    (
                                        <div
                                            key={ind}
                                        />
                                    )
                                })}
                            </GridItem5>

                            <GridItem7>
                                <GridContainerReport>
                                    <GridItem11
                                        className='ml-10 mt--5'
                                    >
                                        <EstudoReportConferenciaDadosFamiliares
                                            values={values}
                                            report={report}
                                            vars={vars}
                                        />
                                    </GridItem11>
                                </GridContainerReport>

                                <GridContainerReport>
                                    <GridItem11
                                        className='ml-10'
                                    >
                                        <EstudoReportConferenciaDadosParametros
                                            values={values}
                                            report={report}
                                        />
                                    </GridItem11>
                                </GridContainerReport>

                                <GridContainerReport>
                                    <GridItem11
                                        className='ml-10'
                                    >
                                        <EstudoReportConferenciaDadosClienteConjuge
                                            values={values}
                                            report={report}
                                        />
                                    </GridItem11>
                                </GridContainerReport>
                            </GridItem7>
                        </GridContainerReport>
                    </>
                :
                    <>
                        <GridContainerReport
                            align='left'
                        >
                            {familiaresList(values)?.map((item, ind) => {
                                return item.id <= HARDCODE.idFamiliarConjuge && !pesquisaList(values.exclusaoFamiliares, item.id).id ? (
                                // item.id <=
                                // (pesquisaList(values.exclusaoFamiliares, HARDCODE.idFamiliarConjuge).id ? HARDCODE.idFamiliarCliente : HARDCODE.idFamiliarConjuge) ? (
                                    <GridItem6
                                        key={ind}
                                    >
                                        <GridContainerReport>
                                            <ClienteConjuge
                                                item={item}
                                            />
                                        </GridContainerReport>
                                    </GridItem6>
                                )
                                :
                                (
                                    <div
                                        key={ind}
                                    />
                                )
                            })}
                        </GridContainerReport>

                        <GridContainerReport>
                            <GridItem12>
                                <EstudoReportConferenciaDadosFamiliares
                                    values={values}
                                    report={report}
                                    vars={vars}
                                />
                            </GridItem12>
                        </GridContainerReport>

                        {!somenteClienteConjugeFamiliares && (
                            <GridContainerReport>
                                <GridItem12>
                                    <EstudoReportConferenciaDadosParametros
                                        values={values}
                                        report={report}
                                    />
                                </GridItem12>
                            </GridContainerReport>
                        )}

                        {!somenteClienteConjugeFamiliares && !somenteClienteConjugeFamiliaresTaxas && (
                            <GridContainerReport>
                                <GridItem12>
                                    <EstudoReportConferenciaDadosClienteConjuge
                                        values={values}
                                        report={report}
                                    />
                                </GridItem12>
                            </GridContainerReport>
                        )}

                        {incluirObjetivos &&
                        //values.objetivosPrincipaisPreocupacoes && values.objetivosPrincipaisPreocupacoes !== HARDCODE.richTextEditorVazio && (
                        informouObjetivos(values) && (
                            <GridContainerReport>
                                <GridItem12>
                                    <div
                                        align="center"
                                        className={
                                            CLASSNAME().formataReportConferenciaDadosObjetivos +
                                                (values.disposicaoRelatorio === HARDCODE.disposicaoRelatorioRetrato ? ' mt-10' : ' mt--1') +
                                                    ' bg-tabelasCabecalhoReport'}
                                    >
                                        <br/>
                                        {LABEL.objetivosPrincipaisPreocupacoesPFCMLP}
                                        <br/>
                                        <br/>
                                    </div>
                                                
                                    {values.objetivosPrincipaisPreocupacoesPFCMLP?.map((item, ind) => (
                                    item.richText && item.richText !== HARDCODE.richTextEditorVazio && (
                                        <EstudoFormObjetivos
                                            values={values}
                                            report={report}
                                            indPagina={ind}
                                        />
                                    )))}
                                </GridItem12>
                            </GridContainerReport>
                        )}
                    </>
            }
        </div>
    )
}

export default EstudoReportConferenciaDados